export const COOKIE_NAMES = {
    ACCESS_TOKEN: 'paysft_token',
} as const;